import React, { PureComponent } from 'react';
import Tiles from '../../components/Tiles/index.js';
import MessageCard from '../../components/Cards/MessageCard.js';
import FileDropZoneModal from '../../components/Modals/DropZoneModal.js';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';
class AccountHistory extends PureComponent {
  state = {
    showCensusModal: false,
    showRateHistoryModal: false,
    showClaimsHistoryModal: false,
    showEmailsModal: false,
    showUploadModal: false,
    successDialogOpen: false,
    rateHistory: null,
    claimsHistory: null,
    pastBill: null,
    supportingDocs: []
  };

  /**
   * Hide all current modals then set the desired modal to the correct state
   * @param type
   * @private
   */
  _toggleModal = type => {
    const currentState = this.state[type];
    this.setState({
      showCensusModal: false,
      showRateHistoryModal: false,
      showClaimsHistoryModal: false,
      showEmailsModal: false,
      showPastBillModal: false,
      showUploadModal: false,
      [type]: !currentState
    });
  };
  collectFiles = async (files, type) => {
    let fileType = null;
    switch (type) {
      case 'Census':
        fileType = 'census';
        break;
      case 'Rate History':
        fileType = 'rateHistory';
        break;
      case 'Claims History':
        fileType = 'claimsHistory';
        break;
      case 'Past Bill':
        fileType = 'pastBill';
        break;
      case 'Emails':
        fileType = 'emails';
        break;
      default:
        fileType = 'supportingDocs';
        break;
    }
    await this.setState({
      [fileType]: files
    });
  };
  _submitFile = async (files, type) => {
    const form = new FormData();
    form.append('type', type);
    switch (type) {
      case 'Census':
        form.append('census', files[0]);
        break;
      case 'Rate History':
        form.append('rateHistory', files[0]);
        break;
      case 'Claims History':
        form.append('claimsHistory', files[0]);
        break;
      case 'Past Bill':
        form.append('pastBill', files[0]);
        break;
      case 'Emails':
        form.append('emails', files[0]);
        break;
      default:
        form.append("supportingDocs", null);
        files.map(item => {
          form.append("supportingDocs", item);
          return true;
        });
        break;
    }
    const success = await this.props.uploadAccountHistory(form, type, this.props.accountID);
    if (success) {
      this.setState({
        successDialogOpen: true
      });
    }
  };
  render() {
    const tiles = [{
      title: i18n.t(tokens.titles.census),
      description: i18n.t(tokens.labels.accountHistory.provideCensusDocument),
      onClick: () => this._toggleModal('showCensusModal')
    }, {
      title: i18n.t(tokens.labels.accountHistory.rateHistory),
      description: i18n.t(tokens.labels.accountHistory.enterRateHistory),
      onClick: () => this._toggleModal('showRateHistoryModal')
    }, {
      title: i18n.t(tokens.labels.accountHistory.claimsHistory),
      description: i18n.t(tokens.labels.accountHistory.enterClaimsHistory),
      onClick: () => this._toggleModal('showClaimsHistoryModal')
    }, {
      title: i18n.t(tokens.labels.accountHistory.pastBill),
      description: i18n.t(tokens.labels.accountHistory.pastBill),
      onClick: () => this._toggleModal('showPastBillModal')
    }, {
      title: i18n.t(tokens.labels.claims.supportingDocuments),
      description: i18n.t(tokens.labels.accountHistory.uploadSupportingDocuments),
      onClick: () => this._toggleModal('showUploadModal')
    }];
    if (this.props.isMasterSite) {
      tiles.push({
        title: i18n.t(tokens.labels.accountHistory.emails),
        description: i18n.t(tokens.labels.accountHistory.uploadEmailsReceived),
        onClick: () => this._toggleModal('showEmailsModal')
      });
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MessageCard, {
      title: i18n.t(tokens.labels.accountHistory.submitAccountHistory),
      subtitle: i18n.t(tokens.labels.accountHistory.uploadCensusRateClaimsHistory),
      btn: this.props.isMasterSite && this.props.downloadAccountHistory,
      btnName: "Download Account History",
      btnOnClick: this.props.downloadAccountHistory
    }), /*#__PURE__*/React.createElement(Tiles, {
      tiles: tiles
    }), this.state.showCensusModal && /*#__PURE__*/React.createElement(FileDropZoneModal, {
      testid: "census-modal",
      title: i18n.t(tokens.labels.accountHistory.selectCensusDocument),
      hideModal: this._toggleModal,
      showModal: this.state.showCensusModal,
      maxItems: 1,
      type: "Census",
      collectFiles: this.collectFiles,
      submitFile: this._submitFile,
      acceptedFiles: "application/vnd.ms-excel, application/pdf, text/csv, .csv, .excel, .xls, .xlsx, .pdf, image/*, .png, .jpg, .jpeg",
      loader: this.props.loader,
      whitelabel: this.props.whitelabel
    }), this.state.showRateHistoryModal && /*#__PURE__*/React.createElement(FileDropZoneModal, {
      testid: "rate-history-modal",
      title: i18n.t(tokens.labels.accountHistory.selectRateHistoryDocument),
      hideModal: this._toggleModal,
      showModal: this.state.showRateHistoryModal,
      maxItems: 1,
      type: "Rate History",
      collectFiles: this.collectFiles,
      submitFile: this._submitFile,
      acceptedFiles: "application/vnd.ms-excel, application/pdf, text/csv, .csv, .excel, .xls, .xlsx, .pdf, image/*, .png, .jpg, .jpeg",
      loader: this.props.loader,
      whitelabel: this.props.whitelabel
    }), this.state.showClaimsHistoryModal && /*#__PURE__*/React.createElement(FileDropZoneModal, {
      testid: "claims-history-modal",
      title: i18n.t(tokens.labels.accountHistory.selectClaimsHistoryDocument),
      hideModal: this._toggleModal,
      showModal: this.state.showClaimsHistoryModal,
      maxItems: 1,
      type: "Claims History",
      collectFiles: this.collectFiles,
      submitFile: this._submitFile,
      acceptedFiles: "application/vnd.ms-excel, application/pdf, text/csv, .csv, .excel, .xls, .xlsx, .pdf, image/*, .png, .jpg, .jpeg",
      loader: this.props.loader,
      whitelabel: this.props.whitelabel
    }), this.state.showPastBillModal && /*#__PURE__*/React.createElement(FileDropZoneModal, {
      testid: "past-bill-modal",
      title: i18n.t(tokens.labels.accountHistory.selectPastBillDocument),
      hideModal: this._toggleModal,
      showModal: this.state.showPastBillModal,
      maxItems: 1,
      type: "Past Bill",
      collectFiles: this.collectFiles,
      submitFile: this._submitFile,
      acceptedFiles: "application/vnd.ms-excel, application/pdf, text/csv, .csv, .excel, .xls, .xlsx, .pdf, image/*, .png, .jpg, .jpeg",
      loader: this.props.loader,
      whitelabel: this.props.whitelabel
    }), this.state.showEmailsModal && /*#__PURE__*/React.createElement(FileDropZoneModal, {
      testid: "email-modal",
      title: i18n.t(tokens.labels.accountHistory.selectEmailDocument),
      hideModal: this._toggleModal,
      showModal: this.state.showEmailsModal,
      maxItems: 1,
      type: "Emails",
      collectFiles: this.collectFiles,
      submitFile: this._submitFile,
      acceptedFiles: "application/vnd.ms-excel, application/pdf, text/csv, .csv, .excel, .xls, .xlsx, .pdf, image/*, .png, .jpg, .jpeg",
      loader: this.props.loader,
      whitelabel: this.props.whitelabel
    }), this.state.showUploadModal && /*#__PURE__*/React.createElement(FileDropZoneModal, {
      testid: "supporting-documents-modal",
      title: i18n.t(tokens.labels.accountHistory.selectSupportingDocuments),
      hideModal: this._toggleModal,
      showModal: this.state.showUploadModal,
      maxItems: 2,
      type: "Supporting Documents",
      collectFiles: this.collectFiles,
      submitFile: this._submitFile,
      acceptedFiles: "application/vnd.ms-excel, application/pdf, text/csv, .csv, .excel, .xls, .xlsx, .pdf, image/*, .png, .jpg, .jpeg",
      loader: this.props.loader,
      whitelabel: this.props.whitelabel
    }), /*#__PURE__*/React.createElement("span", {
      id: "accountHistory"
    }));
  }
}
export default AccountHistory;